import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';
import { StoreMode } from 'src/app/core/enums';
import { ChannelService } from 'src/app/home/channel/channel.service';
import { Channel } from 'src/app/home/channel/channel.model';
import { ChannelSec } from 'src/app/home/channelsec/channelsec.model';
import { SectionDataType } from 'src/app/core/enums/DataType';
import { ThemeService} from 'src/app/shared/services/theme.service';
import { NavigationService } from 'src/app/core/services/navigation.service';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})

export class NewsComponent implements OnInit, OnDestroy {

  channel$: Subscription = new Subscription();
  channelSecData: ChannelSec;
  news: any;
  sectionDataType = SectionDataType;
  formatedDataSet: any = [];

  constructor(
    private channelService: ChannelService,
    private themeService : ThemeService,
    private navigationService: NavigationService
  ) { }

  async ngOnInit() {
    await this.channelService.getChannelDataCheck();

    this.channel$ = this.channelService.get(StoreMode.Internal).subscribe((channelData: Channel) => {
      if (channelData) {
        let channelHomeSecs: any = channelData.data.channelHomeSections;
        this.channelSecData = channelHomeSecs.find(val => val.data.dataType == this.sectionDataType.InfoPanel);
        this.news = this.channelSecData.data.data.find((data: any) => data.dataSet && data.dataSet.length > 0)?.dataSet;
        let tmpFormatedDataSet = [];
        this.news.forEach((data: any) => {
          if (data.infoPanelDs.length > 0) {
            tmpFormatedDataSet.push(this.getInfoPnlData(data));
          }

          return data;
        });

        this.formatedDataSet = tmpFormatedDataSet;

        this.themeService.checkHrefToGetChannelTag();
      }
    });
  }

  getInfoPnlData(dt: any) {
    let data = {
      id: "",
      imgUrlObj: {
        sectionCode: "",
        sectionData: ""
      },
      subtitleObj: {
        sectionData: ""
      },
      titleObj: {
        sectionData: ""
      },
      infoUrl: dt.infoUrl? dt.infoUrl: "",
    };

    if (!dt || (dt.infoPanelDs && dt.infoPanelDs.length === 0)) {
      return data;
    }

    dt.infoPanelDs
      .forEach((val: any) => {
        switch (val["sectionCode"]) {
          case "101": {
            data.titleObj = val;
            break;
          }
          case "102": {
            data.subtitleObj = val;
            break;
          }
          case "201": {
            data.imgUrlObj = val;
            break;
          }
        }
      });

    return data;
  }

  onClickBack() {
    this.navigationService.navigate(['home']);
  }

  onClickCard(infoUrl: string) {
    let newsUrl: URL = infoUrl? new URL(infoUrl): null;
    let currentUrl: URL = new URL(window.location.href);
    let newsUrlArray: string[] = newsUrl?.href && newsUrl.href.includes('/news')? newsUrl.href.split('/news'): null;
    let newsUrlParams: string[] = newsUrlArray && newsUrlArray[1]? newsUrlArray[1].split('/').slice(1): null;

    if(newsUrlArray && (currentUrl.href).includes(newsUrlArray[0]) && newsUrlParams[0] && newsUrlParams[1]) {
      this.navigationService.navigate(["news", newsUrlParams[0], newsUrlParams[1]]);
    } else {
      window.location.href = infoUrl;
    }
  }

  ngOnDestroy(): void {
    this.channel$.unsubscribe();
  }

}
